import COLORS from './colors';

const GLOBAL = {
  BASE_FONT_COLOR: COLORS.GREY_TEN,
  BASE_FONT_FAMILY: 'var(--font-circular-pro), sans-serif',
  BRAND_FONT_FAMILY: 'var(--font-circular-black), sans-serif',
  BRAND_FONT_FAMILY_SECOND: 'var(--font-circular-book), sans-serif',
  BASE_FONT_SIZE: '16px',
  BASE_LINE_HEIGHT: '1.44',
  HEADER_HEIGHT: ['62px', '76px', '94px'],
} as const;

export default GLOBAL;
